import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { AccountService } from '@/services/account.service'
import { InvitesService } from '@/services/invites.service'
import { Loader2 } from 'lucide-react'
import { useEffect, useState } from 'react'
import { toast } from 'sonner'
export default function FastReg({ searchParams }: any) {
	const [email, setEmail] = useState('')
	const [loading, setLoading] = useState(false)

	const productId: string | undefined = searchParams?.product_id
	useEffect(() => {
		const refCode = localStorage.getItem('referralCode')
		if (refCode) {
			setCode(refCode)
		}
	}, [])
	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault()
		setLoading(true)

		AccountService.fastRegister(email, code || undefined)
			.then(response => {
				toast.success('Письмо с доступом отправлено на почту')
				setTimeout(() => {
					if (productId) {
						window.location.href = `/profile/subscriptions/subscribe?product_id=${productId}`
					} else {
						window.location.href = '/profile/subscriptions/subscribe'
					}
				}, 2000)
			})
			.catch(error => {
				toast.error(error.response?.data?.message || 'Ошибка регистрации')
			})
			.finally(() => {
				setLoading(false)
			})
	}
	const [code, setCode] = useState('')
	const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(code)
	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedSearchTerm(code)
		}, 500) // Задержка в 500 мс

		return () => {
			clearTimeout(handler) // Очистка таймера при изменении searchTerm
		}
	}, [code])
	useEffect(() => {
		if (code.length === 0) return
		setTimeout(() => {
			InvitesService.checkCode(code)
				.then(res => {
					if (res.is_active === true) {
						toast.success('Код активен')
					}
				})
				.catch(error => {
					toast.error(error.response?.data?.message || 'Ошибка проверки кода')
				})
		}, 500)
	}, [debouncedSearchTerm])
	return (
		<form
			className='grid gap-4 text-white py-4  w-full max-w-md mx-auto p-6 rounded-lg shadow-lg bg-white/5 backdrop-blur-sm border border-gray-800'
			onSubmit={handleSubmit}
		>
			<Label className='text-3xl font-bold text-gray-200 flex items-center justify-center'>
				Регистрация
			</Label>
			<div className='grid grid-cols-4 items-center gap-4'>
				<Label htmlFor='fastreg-email' className='col-span-4'>
					Email
				</Label>
				<Input
					id='fastreg-email'
					name='email'
					type='email'
					autoComplete='email'
					inputMode='email'
					placeholder='Email'
					className='col-span-4 bg-gray-800 border-gray-700'
					value={email}
					onChange={e => setEmail(e.target.value)}
					disabled={loading}
				/>
			</div>
			<div className='grid grid-cols-4 items-center gap-4'>
				<Label htmlFor='fastreg-code' className='col-span-4'>
					Промокод
				</Label>
				<Input
					id='fastreg-code'
					name='invite_code'
					autoComplete='off'
					placeholder='Есть бонус код?'
					className='col-span-4 bg-gray-800 border-gray-700'
					value={code}
					onChange={e => setCode(e.target.value)}
					disabled={loading}
				/>
			</div>
			<Button
				type='submit'
				className='w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-medium py-2 px-4 rounded-md transition-all duration-200 ease-in-out transform hover:scale-[1.02] active:scale-[0.98]'
				disabled={loading}
			>
				{loading && <Loader2 className='animate-spin' />}
				Зарегистрироваться
			</Button>
		</form>
	)
}
